import { getLocales } from 'assets/locales/Locale';
import LineItem from 'models/enums/LineItem';

export function getLineItemLabel(code: string): string {
  const { lang, translate } = getLocales();

  switch (code) {
    case LineItem.part:
      return lang.part;
    case LineItem.labour:
      return lang.labour;
    case LineItem.other:
      return lang.otherSublet;
    case LineItem.deductible:
      return lang.deductible;
    default:
      return code ? translate(code) : code;
  }
}
